import BaseModel from './base-model.js'
import { useSettings } from '@store/settings'
const $settings = useSettings()

class Staff extends BaseModel {
    /**
     * Set the title of the model
     */
    title = $settings.labels.staff?.singular

    /**
     * Set the id of the model
     */
    route = 'staff'

    /**
     * Primary key of the model
     *
     * @var {string}
     */
    primaryKey = 'staff_id'


    /**
     * Publish
     *
     * @returns
     * @memberof BaseModel
     */
    async publish() {
        return await this.update({
            meta: { status: 'publish' }
        })
    }

    /**
     * Unpublish
     *
     * @returns
     * @memberof BaseModel
     */
    async unpublish() {
        return await this.update({
            meta: { status: 'draft' }
        })
    }

    /**
     * Archive
     */
    async archive() {
        return await this.update({
            meta: { status: 'archive' }
        })
    }
}

export default Staff